import { BlocksIconTaskComplete } from 'blocks-nextjs/blocks-web-components/components/icon/icons/task-complete';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconTaskComplete = createComponent({ react: React, tagName: 'cat-icon-task-complete', elementClass: BlocksIconTaskComplete });
